export const currencyCodes = [
    {
        name: "US Dollar",
        code: "USD"
    },
    {
        name: "Afghan Afghani",
        code: "AFN"
    },
    {
        name: "Albanian lek",
        code: "ALL"
    },
    {
        name: "Algerian Dinar",
        code: "DZD"
    },
    {
        name: "Angolan Kwanza",
        code: "AOA"
    },
    {
        name: "Argentine peso",
        code: "ARS"
    },
    {
        name: "Armenian dram",
        code: "AMD"
    },
    {
        name: "Arubin florin",
        code: "AWG"
    },
    {
        name: "Australian Dollar",
        code: "AUD"
    },
    {
        name: "Azerbaijani manat",
        code: "AZN"
    },
    {
        name: "Bahamian dollar",
        code: "BSD"
    },
    {
        name: "Bahraini Dinar",
        code: "BHD"
    },
    {
        name: "Balboa panamérn",
        code: "PAB"
    },
    {
        name: "Bangladeshi Taka",
        code: "BDT"
    },
    {
        name: "Barbadian dollar",
        code: "BBD"
    },
    {
        name: "Belarusian ruble",
        code: "BYN"
    },
    {
        name: "Belize dollar",
        code: "BZD"
    },
    {
        name: "Bermudian dollar",
        code: "BMD"
    },
    {
        name: "Bhutanese Ngultrum",
        code: "BTN"
    },
    {
        name: "Bolivian Boliviano",
        code: "BOB"
    },
    {
        name: "Bosnian Convertible Marka",
        code: "BAM"
    },
    {
        name: "Botswana Pula",
        code: "BWP"
    },
    {
        name: "Brazilian real",
        code: "BRL"
    },
    {
        name: "British Pound",
        code: "GBP"
    },
    {
        name: "Bruneian Dollar",
        code: "BND"
    },
    {
        name: "Bulgarian lev",
        code: "BGN"
    },
    {
        name: "Burmese Kyat",
        code: "MMK"
    },
    {
        name: "Burundian Franc",
        code: "BIF"
    },
    {
        name: "Cambodian Riel",
        code: "KHR"
    },
    {
        name: "Canadian Dollar",
        code: "CAD"
    },
    {
        name: "Cape Verdean Escudo",
        code: "CVE"
    },
    {
        name: "Caymanian Dollar",
        code: "KYD"
    },
    {
        name: "CFA Franc",
        code: "XOF"
    },
    {
        name: "CFP Franc",
        code: "XPF"
    },
    {
        name: "Chilean Peso",
        code: "CLP"
    },
    {
        name: "Chinese Yuan",
        code: "CNY"
    },
    {
        name: "Colombian peso",
        code: "COP"
    },
    {
        name: "Comoran Franc",
        code: "KMF"
    },
    {
        name: "Costa Rican colón",
        code: "CRC"
    },
    {
        name: "Croatian kuna",
        code: "HRK"
    },
    {
        name: "Cuban convertible peso",
        code: "CUC"
    },
    {
        name: "Cuban peso",
        code: "CUP"
    },
    {
        name: "Czech koruna",
        code: "CZK"
    },
    {
        name: "Danish krone",
        code: "DKK"
    },
    {
        name: "Djiboutian Franc",
        code: "DJF"
    },
    {
        name: "Dominican peso",
        code: "DOP"
    },
    {
        name: "Dutch Guilder",
        code: "ANG"
    },
    {
        name: "East Caribbean dollar",
        code: "XCD"
    },
    {
        name: "Egyptian Pound",
        code: "EGP"
    },
    {
        name: "Emirati Dirham",
        code: "AED"
    },
    {
        name: "Eritrean nakfa",
        code: "ERN"
    },
    {
        name: "Ethiopian Birr",
        code: "ETB"
    },
    {
        name: "Euro",
        code: "EUR"
    },
    {
        name: "Falkland Island Pound",
        code: "FKP"
    },
    {
        name: "Fijian dollar",
        code: "FJD"
    },
    {
        name: "Gambian dalasi",
        code: "GMD"
    },
    {
        name: "Georgian lari",
        code: "GEL"
    },
    {
        name: "Ghanaian Cedi",
        code: "GHS"
    },
    {
        name: "Gibraltar pound",
        code: "GIP"
    },
    {
        name: "Guatemalan Quetzal",
        code: "GTQ"
    },
    {
        name: "Guinean Franc",
        code: "GNF"
    },
    {
        name: "Guyanese dollar",
        code: "GYD"
    },
    {
        name: "Haitian gourde",
        code: "HTG"
    },
    {
        name: "Honduran lempira",
        code: "HNL"
    },
    {
        name: "Hong Kong dollar",
        code: "HKD"
    },
    {
        name: "Hungarian forint",
        code: "HUF"
    },
    {
        name: "Icelandic Krona",
        code: "ISK"
    },
    {
        name: "Indian Rupee",
        code: "INR"
    },
    {
        name: "Indonesian Rupiah",
        code: "IDR"
    },
    {
        name: "Iranian Rial",
        code: "IRR"
    },
    {
        name: "Iraqi Dinar",
        code: "IQD"
    },
    {
        name: "Israeli Shekel",
        code: "ILS"
    },
    {
        name: "Jamaican dollar",
        code: "JMD"
    },
    {
        name: "Japanese yen",
        code: "JPY"
    },
    {
        name: "Jordanian Dinar",
        code: "JOD"
    },
    {
        name: "Kazakhstani tenge",
        code: "KZT"
    },
    {
        name: "Kenyan Shilling",
        code: "KES"
    },
    {
        name: "Kuwaiti Dinar",
        code: "KWD"
    },
    {
        name: "Kyrgyzstani som",
        code: "KGS"
    },
    {
        name: "Lao or Laotian Kip",
        code: "LAK"
    },
    {
        name: "Lebanese Pound",
        code: "LBP"
    },
    {
        name: "Lesotho loti",
        code: "LSL"
    },
    {
        name: "Liberian Dollar",
        code: "LRD"
    },
    {
        name: "Libyan Dinar",
        code: "LYD"
    },
    {
        name: "Lithuanian litas",
        code: "LTL"
    },
    {
        name: "Macau Pataca",
        code: "MOP"
    },
    {
        name: "Macedonian Denar",
        code: "MKD"
    },
    {
        name: "Malagasy Ariary",
        code: "MGA"
    },
    {
        name: "Malawian Kwacha",
        code: "MWK"
    },
    {
        name: "Malaysian Ringgit",
        code: "MYR"
    },
    {
        name: "Maldivian Rufiyaa",
        code: "MVR"
    },
    {
        name: "Mauritanian Ouguiya",
        code: "MRO"
    },
    {
        name: "Mauritian rupee",
        code: "MUR"
    },
    {
        name: "Mexico Peso",
        code: "MXN"
    },
    {
        name: "Moldovan Leu",
        code: "MDL"
    },
    {
        name: "Mongolian Tughrik",
        code: "MNT"
    },
    {
        name: "Moroccan Dirham",
        code: "MAD"
    },
    {
        name: "Mozambican Metical",
        code: "MZN"
    },
    {
        name: "Namibian Dollar",
        code: "NAD"
    },
    {
        name: "Nepalese Rupee",
        code: "NPR"
    },
    {
        name: "New Zealand Dollar",
        code: "NZD"
    },
    {
        name: "Ni-Vanuatu Vatu",
        code: "VUV"
    },
    {
        name: "Nicaraguan córdoba",
        code: "NIO"
    },
    {
        name: "Nigerian Naira",
        code: "NGN"
    },
    {
        name: "North Korean won",
        code: "KPW"
    },
    {
        name: "Norwegian krone",
        code: "NOK"
    },
    {
        name: "Omani Rial",
        code: "OMR"
    },
    {
        name: "Pakistani Rupee",
        code: "PKR"
    },
    {
        name: "Papua New Guinean Kina",
        code: "PGK"
    },
    {
        name: "Paraguayan guarani",
        code: "PYG"
    },
    {
        name: "Peruvian nuevo sol",
        code: "PEN"
    },
    {
        name: "Philippine Peso",
        code: "PHP"
    },
    {
        name: "Polish złoty",
        code: "PLN"
    },
    {
        name: "Qatari Riyal",
        code: "QAR"
    },
    {
        name: "Romanian leu",
        code: "RON"
    },
    {
        name: "Russian Rouble",
        code: "RUB"
    },
    {
        name: "Rwandan franc",
        code: "RWF"
    },
    {
        name: "Samoan Tālā",
        code: "WST"
    },
    {
        name: "Saudi Arabian Riyal",
        code: "SAR"
    },
    {
        name: "Serbian Dinar",
        code: "RSD"
    },
    {
        name: "Seychellois Rupee",
        code: "SCR"
    },
    {
        name: "Sierra Leonean Leone",
        code: "SLL"
    },
    {
        name: "Singapore Dollar",
        code: "SGD"
    },
    {
        name: "Solomon Islander Dollar",
        code: "SBD"
    },
    {
        name: "Somali Shilling",
        code: "SOS"
    },
    {
        name: "South African Rand",
        code: "ZAR"
    },
    {
        name: "South Korean won",
        code: "KRW"
    },
    {
        name: "South Sudanese pound",
        code: "SSP"
    },
    {
        name: "Sri Lankan Rupee",
        code: "LKR"
    },
    {
        name: "Sudanese Pound",
        code: "SDG"
    },
    {
        name: "Surinamese dollar",
        code: "SRD"
    },
    {
        name: "Swazi Lilangeni",
        code: "SZL"
    },
    {
        name: "Swedish krona",
        code: "SEK"
    },
    {
        name: "Swiss Franc",
        code: "CHF"
    },
    {
        name: "Syrian Pound",
        code: "SYP"
    },
    {
        name: "Taiwan New Dollar",
        code: "TWD"
    },
    {
        name: "Tajikistani somoni",
        code: "TJS"
    },
    {
        name: "Tanzanian Shilling",
        code: "TZS"
    },
    {
        name: "Thai Baht",
        code: "THB"
    },
    {
        name: "Tongan Pa'anga",
        code: "TOP"
    },
    {
        name: "Trinidadian dollar",
        code: "TTD"
    },
    {
        name: "Tunisian Dinar",
        code: "TND"
    },
    {
        name: "Turkish Lira",
        code: "TRY"
    },
    {
        name: "Turkmenistan manat",
        code: "TMT"
    },
    {
        name: "Ugandan Shilling",
        code: "UGX"
    },
    {
        name: "Ukrainian Hryvnia",
        code: "UAH"
    },
    {
        name: "Uruguayan peso",
        code: "UYU"
    },
    {
        name: "Uzbekistani som",
        code: "UZS"
    },
    {
        name: "Venezuelan bolivar",
        code: "VEF"
    },
    {
        name: "Vietnamese Dong",
        code: "VND"
    },
    {
        name: "Yemeni Rial",
        code: "YER"
    },
    {
        name: "Zambian Kwacha",
        code: "ZMW"
    },
    {
        name: "Zimbabwean Dollar",
        code: "ZWD"
    }
];